// ============================================
// RIVA THEME - CUSTOM JAVASCRIPT
// ============================================
//
// TABLE OF CONTENTS:
// 1. Mobile Navigation  → //#region Mobile Navigation
// 2. Initialization     → //#region Initialization
//
// Last updated: 2025-10-09
//
// ============================================


//#region Mobile Navigation
// ================================================
// AI EDITING INSTRUCTIONS:
// - All mobile nav code belongs ONLY in this region
// - Update existing class, don't create duplicate
// ================================================

class RivaMobileNav {
  constructor() {
    this.hamburger = document.querySelector('.riva-header__hamburger');
    this.menu = document.querySelector('.riva-mobile-menu');
    this.overlay = document.querySelector('.riva-mobile-menu__overlay');
    this.closeBtn = document.querySelector('.riva-mobile-menu__close');
    this.body = document.body;

    if (this.hamburger && this.menu) {
      this.init();
    }
  }

  init() {
    // Hamburger click
    this.hamburger.addEventListener('click', () => this.toggle());

    // Close button click
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });

    // Close on menu link click (for single-page nav)
    const menuLinks = this.menu.querySelectorAll('.riva-mobile-menu__link');
    menuLinks.forEach(link => {
      link.addEventListener('click', () => {
        // Small delay to allow navigation
        setTimeout(() => this.close(), 100);
      });
    });
  }

  toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.menu.classList.add('is-open');
    this.hamburger.classList.add('is-active');

    if (this.overlay) {
      this.overlay.classList.add('is-visible');
    }

    // Prevent body scroll when menu is open
    this.body.style.overflow = 'hidden';

    // Accessibility: focus on menu
    this.menu.focus();
  }

  close() {
    this.menu.classList.remove('is-open');
    this.hamburger.classList.remove('is-active');

    if (this.overlay) {
      this.overlay.classList.remove('is-visible');
    }

    // Restore body scroll
    this.body.style.overflow = '';

    // Return focus to hamburger button
    this.hamburger.focus();
  }

  isOpen() {
    return this.menu.classList.contains('is-open');
  }
}

//#endregion


//#region Initialization
// ================================================
// AI EDITING INSTRUCTIONS:
// - Component initialization belongs ONLY here
// - Add new initializations to this region
// ================================================

document.addEventListener('DOMContentLoaded', () => {
  // Initialize mobile navigation
  new RivaMobileNav();

  // Log for debugging
  console.log('Riva theme initialized');
});

//#endregion
